import getOffset from 'document-offset';
import canvasUtils from '../utils';

const hoverElementWidth = 0;

export default {
  add(element, silent) {
    const hoverElement = document.createElement('div');
    const canvas = element.ownerDocument.body;
    const offset = getOffset(element);
    const zoom = canvas.getAttribute('data-gp-zoom')?parseInt(canvas.getAttribute('data-gp-zoom')):1;
    const top = this.getTopPosition(element, zoom, offset);
    const left = this.getLeftPosition(canvas, element, zoom, offset);
    const height = this.getHeight(top, element, zoom);
    const width = this.getWidth(left, element, zoom);
    hoverElement.style.top = `${ top }px`;
    hoverElement.style.left = `${ left }px`;
    hoverElement.style.width = `${ width }px`;
    hoverElement.style.height = `${ height }px`;
    if (!( silent && canvas.querySelector('.ql-editor') )) {
      hoverElement.classList.add('gp-component-hover');

      if( element.getAttribute('data-gp-component') )
        hoverElement.classList.add(
          `gp-component-${element
            .getAttribute('data-gp-component')
            .replaceAll(' ', '_')}`
        );
    }
    const blocksContainer = canvas.querySelector('.blocks-container');
    if (blocksContainer) {
      const firstComponent = blocksContainer.querySelector('.gp-component');
      if (firstComponent) {
        hoverElement.classList.add('first-block');
      }
    }

    canvas.appendChild(hoverElement);
    return hoverElement;
  },
  getTopPosition(element, zoom, offset) {
    // need to subtract window.pageYOffset, <html> scrollTop as document-offset occasionally adds it erroneously.
    let top = offset.top - window.pageYOffset;

    if( element?.ownerDocument?.defaultView )
      top += element.ownerDocument.defaultView.scrollY - element.ownerDocument.body.parentNode.scrollTop;

    top *= zoom;
    if (top < hoverElementWidth) return hoverElementWidth;
    return top;
  },
  getLeftPosition(canvas, element, zoom, offset) {
    const widthOffset =
      (canvas.offsetWidth - canvas.getBoundingClientRect().width) / 2;
    let left = offset.left - widthOffset;
    left *= zoom;
    if (left < hoverElementWidth) return hoverElementWidth;
    return left;
  },
  getHeight(top, element, zoom) {
    let height = element.getBoundingClientRect().height * zoom;
    if (top === hoverElementWidth) height -= hoverElementWidth;

    let valueToCheck = top + height + hoverElementWidth;

    if( element?.ownerDocument?.defaultView )
      valueToCheck += element.ownerDocument.defaultView.scrollY;

    if ( element?.ownerDocument && valueToCheck >= element.ownerDocument.body.scrollHeight )
      height -= hoverElementWidth;

    return height;
  },
  getWidth(left, element, zoom) {
    const width = element.getBoundingClientRect().width * zoom;

    let valueToCheck = left + width + hoverElementWidth;

    if( element && element.ownerDocument && element.ownerDocument.defaultView)
      valueToCheck += element.ownerDocument.defaultView.scrollX;

    if ( element && element.ownerDocument && valueToCheck >= element.ownerDocument.body.scrollWidth ) {
      return element.ownerDocument.body.scrollWidth - left - hoverElementWidth;
    }
    return width;
  },
  addMenu(hoverElement, menu) {
    hoverElement.appendChild(menu);
    const menuHeight = menu.offsetHeight;
    const menuWidth = menu.offsetWidth;
    const frameWidth = hoverElement.ownerDocument.defaultView?.innerWidth;
    const clearanceTop = parseInt(hoverElement.style.top);
    const hoverElementHeight = parseInt(hoverElement.style.height);
    const hoverElementWidth = parseInt(hoverElement.style.width);
    const clearanceRight = frameWidth - parseInt(hoverElement.style.left);

    let left = 0;
    let top = 0;
    if (menuHeight > clearanceTop && hoverElementHeight < menuHeight) top = hoverElementHeight;
    else if (menuHeight < clearanceTop) top = -menuHeight;

    if (menuWidth > clearanceRight) left = -menuWidth + hoverElementWidth;

    menu.style.top = `${top}px`;
    menu.style.left = `${left}px`;
  },
  addUpDownButton(hoverElement, hoveredComponent) {
    const isPrev = canvasUtils.getPrevSibling(hoveredComponent.getElement(), '[data-gp-block]');
    const isNext = canvasUtils.getNextSibling(hoveredComponent.getElement(), '[data-gp-block]');
    const menu = document.createElement('div');
    menu.classList.add('gp-component-menu');

    if (isPrev) {
      const upIcon = canvasUtils.getMenuButton('up-arrow');
      menu.appendChild(upIcon);
      upIcon.addEventListener('click', () => hoveredComponent.moveUp(isPrev));
    }

    if (isNext) {
      const downIcon = canvasUtils.getMenuButton('down-arrow');
      menu.appendChild(downIcon);
      downIcon.addEventListener('click', () => hoveredComponent.moveDown(isNext));
    }

    menu.style.right = 0;
    menu.style.top = 0;
    hoverElement.appendChild(menu);
    return menu;
  },
  addDragButton(hoverElement) {
    const dragButton = canvasUtils.createMenuButton({
      icon: 'icon-drag',
      title: 'Drag',
      callback: (e) => e.preventDefault()
    });
    dragButton.classList.add('gp-component-drag-button');
    setTimeout(() => {
      hoverElement.querySelector('.gp-component-menu').prepend(dragButton);
    },0);
    return dragButton;
  },
  setDragState(e, canvas, dragButton) {
    if (
      canvas.body.classList.contains('draggable--is-dragging') ||
      !dragButton
    ) {
      return;
    }
    const bounds = dragButton.getBoundingClientRect();
    const left = bounds.x - 34;
    const right = left + 32;
    const top = bounds.y;
    const bottom = top + 32;

    const inBounds = e.x > left && e.x < right && e.y > top && e.y < bottom;
    if (inBounds) {
      canvas.body.classList.add('gp-drag-enabled');
    } else {
      canvas.body.classList.remove('gp-drag-enabled');
    }
  },
  fitInside(inner, outer) {
    const outerHeight = parseInt(outer.style.height);
    const outerWidth = parseInt(outer.style.width);
    const outerLeft = parseInt(outer.style.left);
    const outerTop = parseInt(outer.style.top);
    let innerHeight = parseInt(inner.style.height);
    let innerWidth = parseInt(inner.style.width);
    let innerLeft = parseInt(inner.style.left);
    let innerTop = parseInt(inner.style.top);
    if (outerHeight < innerHeight || outerWidth < innerWidth) return;
    if (innerLeft < outerLeft + hoverElementWidth) {
      innerLeft = outerLeft + hoverElementWidth;
    }
    if (innerLeft + innerWidth > outerLeft + outerWidth - hoverElementWidth) {
      innerWidth = outerLeft + outerWidth - hoverElementWidth - innerLeft;
    }
    if (innerTop < outerTop + hoverElementWidth) {
      innerTop = outerTop + hoverElementWidth;
    }
    if (innerTop + innerHeight > outerTop + outerHeight - hoverElementWidth) {
      innerHeight = outerTop + outerHeight - hoverElementWidth - innerTop;
    }
    inner.style.top = `${innerTop}px`;
    inner.style.left = `${innerLeft}px`;
    inner.style.width = `${innerWidth}px`;
    inner.style.height = `${innerHeight}px`;
  }
};
